export const onInitialClientRender = () => {
  document.documentElement.style.visibility = 'visible'
}
